// Font family strings for use in components.
// The actual @import is in index.html (Google Fonts).
// These strings match the CSS variables defined in globals.css.

export const FONT_SANS = "Inter, ui-sans-serif, system-ui, -apple-system, sans-serif";
export const FONT_SERIF = "\"Instrument Serif\", ui-serif, Georgia, serif";
export const FONT_DISPLAY = "\"Instrument Serif\", ui-serif, Georgia, serif";
export const FONT_MONO = "ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, monospace";

// Font class names for use in components (mirrors original instrumentSerif.className)
export const instrumentSerif = {
  className: "font-display",
};

export const inter = {
  variable: "--font-inter",
};

export const instrumentSerifItalic = {
  variable: "--font-instrument-serif-italic",
};